import { DataGrid as MuiDataGrid, GridColDef } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { heIL } from '@mui/x-data-grid/locales';
import React from 'react';

interface CustomDataGridProps {
  rows: any[];
  columns: GridColDef[];
  rowCount?: number;
  loading: boolean;
  page?: number;
  pageSize?: number;
  paginationMode?: 'client' | 'server';
  checkboxSelection?: boolean;
  getRowClassName?: (params: any) => string;
  onPageChange?: (page: number) => void;
  onPageSizeChange?: (pageSize: number) => void;
  onSelectionChange?: (ids: (string | number)[]) => void;
  hideHeaders?: boolean;
  rowHeight?: number;
}

const CustomDataGrid: React.FC<CustomDataGridProps> = ({
  rows,
  columns,
  loading,
  rowCount,
  page = 0,
  pageSize = 10,
  paginationMode = 'server',
  checkboxSelection = true,
  getRowClassName,
  onPageChange,
  onPageSizeChange,
  onSelectionChange,
  hideHeaders = false,
  rowHeight,
}) => {
  return (
    <Box className="dashboard-table">
      <MuiDataGrid
        rows={rows}
        columns={columns}
        paginationMode={paginationMode}
        {...(paginationMode === 'server' && rowCount !== undefined ? { rowCount } : {})}
        paginationModel={{ page, pageSize }}
        onPaginationModelChange={({ page, pageSize }) => {
          onPageChange?.(page);
          onPageSizeChange?.(pageSize);
        }}
        loading={loading}
        pageSizeOptions={[5, 10, 20]}
        checkboxSelection={checkboxSelection}
        getRowClassName={getRowClassName}
        disableRowSelectionOnClick
        disableColumnResize
        columnBuffer={0}
        localeText={heIL.components.MuiDataGrid.defaultProps.localeText}
        columnHeaderHeight={hideHeaders ? 0 : undefined}
        rowHeight={rowHeight}
        sx={{
          border: 0,
          '& .MuiTablePagination-spacer': {
            display: 'none',
          },
          ...(hideHeaders
            ? {
                '& .MuiDataGrid-columnHeaders': {
                  display: 'none !important',
                  minHeight: '0px !important',
                  height: '0px !important',
                },
              }
            : {}),
        }}
        componentsProps={{
          baseCheckbox: {
            icon: <RadioButtonUncheckedIcon />,
            checkedIcon: <CheckCircleIcon />,
            sx: { color: 'transparent' },
          },
        }}
        onRowSelectionModelChange={(ids) => {
          onSelectionChange?.(ids);
        }}
      />
    </Box>
  );
};

export default CustomDataGrid;
